import React from 'react';

const footerColumns = [
  {
    title: 'Programs',
    links: [{ label: 'Ambassador', href: '/ambassador' }],
  },
  {
    title: 'Products',
    links: [
      { label: 'Accounts', href: '/accounts' },
      { label: 'Cards', href: '/cards' },
      { label: 'Scallop Pay', href: '/scallop-pay' },
      { label: 'Scallop Plus', href: '/scallop-plus' },
      { label: 'Navigator', href: 'https://navigator.scallopx.com/', external: true },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact Us', href: '/support' },
      { label: 'FAQs', href: '/helpcenter' },
      {
        label: 'Scallop Docs',
        href: 'https://docs.scallopx.com/',
        external: true,
      },
      { label: 'Blogs', href: 'https://blog.scallopx.com/', external: true },

    ],
  },
];

function FooterColumn({ title, links }) {
  return (
    <div className="site-footer__column">
      <h3 className="site-footer__heading">{title}</h3>
      <ul className="site-footer__list">
        {links.map(({ label, href, external }) => (
          <li key={label} className="site-footer__item">
            <a
              className="site-footer__link"
              href={href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener noreferrer' : undefined}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <div className="site-footer__logo" aria-hidden="true">
            <svg viewBox="0 0 699 196" className="site-footer__svg">
              <use href="#svg-1137231340_6119" />
            </svg>
          </div>

          <div className="site-footer__headline">
            <strong>One account for all your currencies</strong>
            <br />
            Manage, send, and receive money globally
          </div>

          <div className="site-footer__badge" aria-hidden="true">
            <img
              decoding="async"
              width="1440"
              height="1440"
              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
              alt=""
            />
          </div>

          <div className="scallop-compliance-note">
            <p>
              This website is managed by Scallop Pvt Limited, Sri Lanka.
              <br />
              Scallop does not provide services in the countries listed on its{' '}
              <a
                href="https://docs.scallopx.com/details/onboarding-regions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Prohibited Countries list
              </a>
              .
            </p>
          </div>
        </div>

        <div className="site-footer__columns">
          {footerColumns.map((column) => (
            <FooterColumn
              key={column.title}
              title={column.title}
              links={column.links}
            />
          ))}
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__copyright">
          <svg viewBox="0 0 20 20" className="site-footer__copyright-icon" aria-hidden="true">
            <use href="#svg-1839680863_948" />
          </svg>
          <span>2026 Scallop Group. All rights reserved.</span>
        </div>

        <div className="site-footer__socials" aria-label="Scallop social links">
          <a
            href="https://x.com/Scallopcom"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__social-link"
            aria-label="X"
          >
            X
          </a>
          <a
            href="https://www.linkedin.com/company/scallopcom"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__social-link"
            aria-label="LinkedIn"
          >
            in
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
